import axios from 'axios';

const BASE  = process.env.REACT_APP_API_BASE_URL;
const TOKEN = process.env.REACT_APP_API_TOKEN;

const client = axios.create({
  baseURL: BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export async function getRootSurvey() {
  const { data } = await client.get(`/frontapi/getrootsurvey/${TOKEN}`);
  return data;
}

export async function submitVote(payload) {
  const { data } = await client.post(`/frontapi/vote/${TOKEN}`, payload);
  return data;
}

export async function sendNomineeOtp(votingCode) {
  const { data } = await client.get(`/frontapi/generateotp/${votingCode}/${TOKEN}`);
  return data;
}

export async function verifyNomineeOtp(votingCode, otp) {
  const { data } = await client.post(`/frontapi/verifyotp/${votingCode}/${TOKEN}`, { otp });
  return data;
}

export async function uploadNomineePhoto(votingCode, otp, imageFile) {
  const form = new FormData();
  form.append('otp', otp);
  form.append('image', imageFile);
  const { data } = await client.post(`/frontapi/uploadnomineeimage/${votingCode}/${TOKEN}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function requestNomineePin(nomineeCode) {
  const { data } = await client.post(`/frontapi/nominee-votes/request-pin/${TOKEN}`, { nominee_code: nomineeCode });
  return data;
}

export async function getNomineeVotes(nomineeCode, pin) {
  const { data } = await client.post(`/frontapi/nominee-votes/${TOKEN}`, { nominee_code: nomineeCode, pin });
  return data;
}

export async function getVoteStatus(ref) {
  const { data } = await client.get(`/frontapi/vote/status/${ref}/${TOKEN}`);
  return data;
}
